
import axiosInstance from "../utils/AxiosInstance";

const API_URL = `/auth`; // Replace with your actual API URL


// Login User

// Reset Password


// Fetch User Table
export const fetchUserTable = async (page: number, limit: number, userType: string) => {
  const response = await axiosInstance.get(`${API_URL}/table?page=${page}&limit=${limit}&userType=${userType}`);
  return response.data;
};

